import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiDeleteActivationRequest extends ApiRequestor {
  async $deleteActivation(activationId, organizationId) {
    const payload = {organizationId};
    return this.$http('DELETE', `bookedActivity/${activationId}`, {payload});
  }
}
